<script setup>
defineProps({
  type: {
    type: String,
    default: 'table',
    validator: (v) => ['table', 'card', 'list', 'text'].includes(v)
  },
  rows: {
    type: Number,
    default: 5
  }
})
</script>

<template>
  <!-- TABLE skeleton -->
  <div v-if="type === 'table'" class="w-full space-y-2">
    <!-- Header row -->
    <div class="flex gap-3 px-4 py-2">
      <div class="shimmer bg-navy-mid h-4 rounded w-1/4"></div>
      <div class="shimmer bg-navy-mid h-4 rounded w-1/5"></div>
      <div class="shimmer bg-navy-mid h-4 rounded w-1/6"></div>
      <div class="shimmer bg-navy-mid h-4 rounded w-1/5"></div>
      <div class="shimmer bg-navy-mid h-4 rounded w-1/6"></div>
    </div>
    <!-- Data rows -->
    <div
      v-for="i in rows"
      :key="i"
      class="flex gap-3 px-4 py-3 bg-navy-mid rounded-md"
    >
      <div class="shimmer bg-navy-light h-4 rounded w-1/4"></div>
      <div class="shimmer bg-navy-light h-4 rounded w-1/5"></div>
      <div class="shimmer bg-navy-light h-4 rounded w-1/6"></div>
      <div class="shimmer bg-navy-light h-4 rounded w-1/5"></div>
      <div class="shimmer bg-navy-light h-4 rounded w-1/6"></div>
    </div>
  </div>

  <!-- LIST skeleton -->
  <div v-else-if="type === 'list'" class="w-full space-y-3">
    <div
      v-for="i in rows"
      :key="i"
      class="flex items-center gap-3 px-4 py-3 bg-navy-mid rounded-md"
    >
      <!-- Round icon placeholder -->
      <div class="shimmer bg-navy-light w-9 h-9 rounded-full flex-shrink-0"></div>
      <!-- Text lines -->
      <div class="flex-1 space-y-2">
        <div class="shimmer bg-navy-light h-3.5 rounded w-2/3"></div>
        <div class="shimmer bg-navy-light h-3 rounded w-1/3"></div>
      </div>
    </div>
  </div>

  <!-- CARD skeleton -->
  <div v-else-if="type === 'card'" class="bg-navy-mid rounded-[20px] p-5 space-y-4">
    <!-- Icon + value row -->
    <div class="flex items-center justify-between">
      <div class="shimmer bg-navy-light w-10 h-10 rounded-lg"></div>
      <div class="shimmer bg-navy-light h-7 rounded w-1/3"></div>
    </div>
    <!-- Title line -->
    <div class="shimmer bg-navy-light h-3.5 rounded w-1/2"></div>
    <!-- Subtitle / trend line -->
    <div class="shimmer bg-navy-light h-3 rounded w-1/4"></div>
  </div>

  <!-- TEXT skeleton -->
  <div v-else-if="type === 'text'" class="w-full space-y-2">
    <div
      v-for="i in rows"
      :key="i"
      class="shimmer bg-navy-mid h-4 rounded"
      :style="{ width: (55 + (i * 13) % 45) + '%' }"
    ></div>
  </div>
</template>
